import { Box, Card, Grid, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

const UpdatesOutstandingDemand = ({ demands }) => {
    console.log(demands)
    const navigate = useNavigate()
    const handleBoxClick = (id) => {
        navigate(`/atom-pro/income-tax/demand/${id}`);
    };
    return (
        <>
            {demands && demands?.newItem && demands?.newItem?.length > 0 && (
                <Grid container spacing={1}>
                    <Grid item xs={12}>
                        <Typography variant="h5" color={"primary"}>New Outstanding Demands : {demands?.newItem?.length}</Typography>
                    </Grid>

                    {demands?.newItem?.map(item => (
                        <Grid item xs={4} key={item.id}>
                            <Card >
                                <Grid item sx={{ marginBottom: 1 }} onClick={() => handleBoxClick(item.id)} bgcolor={"#ffffff"} m={0.5} padding={0.5}>
                                    <Typography variant="body2"> <span style={{ fontWeight: "600", color: "#00264d" }}>DIN : </span> {item?.din}</Typography>
                                    <Typography variant="body2" ><span style={{ fontWeight: "600", color: "#00264d" }}>Section Code : </span> {item?.sectionCode}</Typography>
                                    <Typography variant="body2" ><span style={{ fontWeight: "600", color: "#00264d" }}>Current Status : </span> {item?.currentStatus}</Typography>

                                </Grid>
                            </Card>
                        </Grid>
                    ))}
                </Grid>
            )}
        </>
    )
}

export default UpdatesOutstandingDemand